import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const scrollLockDirective = {
	beforeMount(el, binding) {
		if (binding.value) disableBodyScroll(el);
	},

	updated(el, binding) {
		if (binding.value !== binding.oldValue) {
			if (binding.value) disableBodyScroll(el);
			else enableBodyScroll(el);
		}
	},

	unmounted(el) {
		enableBodyScroll(el);
	},
};

export function install(app) {
	app.directive('scroll-lock', scrollLockDirective);
}

export default scrollLockDirective;
